import { useTranslation } from "react-i18next";
import './section4.scss'
export const useSection4 = () => {
  const { t } = useTranslation();

  return {
    t
  };
};
